import { get, merge } from 'lodash';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

const request = {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'upcoming_assignments',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

const initialState = {
  ...requestInitialState,
  pagination: {
    offset: 0,
    limit: 10,
  },
};

const supportedActions = [
  'REMOVE_ITEMS',
  'CLEAR',
  'DELETE_ANSWERED_ITEM',
  'UPDATE_ITEM',
];

export const consts = createReqConsts('surveys', 'upcoming', supportedActions);
export const paginatedConsts = createReqConsts('surveys', 'upcomingPaginated', [
  'LOAD_NEXT_REQUESTS',
  'UPDATE_PAGINATION_PARAMETERS',
]);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);
export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  request,
);

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        { list: action.payload },
      );
    }
    case paginatedConsts.SUCCEED: {
      const prevList = get(state, 'list', []);
      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        list: prevList.concat(action.payload),
      });
    }
    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS: {
      const { offset, limit } = action.payload;
      return merge({}, state, {
        pagination: {
          offset,
          limit,
        },
      });
    }
    case consts.DELETE_ANSWERED_ITEM: {
      const id = action.payload;
      const prevList = get(state, 'list', []);
      const list = prevList.filter(item => id !== get(item, 'assignmentId'));
      const prevCount = get(state, ['meta', 'totalCount'], 0);

      return {
        ...state,
        list,
        meta: {
          totalCount: prevCount - 1,
        },
      };
    }
    case consts.REMOVE_ITEMS: {
      if (!state.list) return state;

      const updatedList = state.list.filter(
        item => !payload.includes(item.assignmentId),
      );
      const currentTotalCount = get(state, 'meta.totalCount');
      return {
        ...state,
        list: updatedList,
        meta: { totalCount: currentTotalCount - 1 },
      };
    }

    case consts.UPDATE_ITEM: {
      if (!state.list) return state;

      const updatedList = state.list.map(item => {
        if (item.assignmentId === payload.assignmentId) {
          return payload;
        }
        return item;
      });

      return {
        ...state,
        list: updatedList,
      };
    }
    case consts.CLEAR:
      return initialState;

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/surveys/upcoming.js